import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { NgModule } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { MatInputModule } from "@angular/material/input";
import { HttpClient } from "@angular/common/http";
import { MdbModalRef, MdbModalService } from "mdb-angular-ui-kit/modal";
import Swal from "sweetalert2";
import { Router } from "@angular/router";
import { RouterModule, Route } from "@angular/router";
import { ActivatedRoute } from "@angular/router";
import { Inject } from "@angular/core";
import { PasswordValidation } from "./validator";
import { environment } from "src/environments/environment";
import { NgPasswordValidatorModule } from "ng-password-validator";
// @Inject(ActivatedRoute)

@Component({
  selector: "app-reset-pass",
  templateUrl: "./reset-pass.component.html",
  styleUrls: ["./reset-pass.component.scss"],
})
export class ResetPassComponent implements OnInit {
  private $route: ActivatedRoute;
  firstFormGroup: FormGroup;
  hide = true;
  filled: any;
  param: any;
  name: any;
  Code: any;
  gets: any;
  list2: any;
  myError: any;
  // ConfirmedValidator:any;
  constructor(
    private activeRoute: ActivatedRoute,
    private route: ActivatedRoute,
    private _activatedroute: ActivatedRoute,
    private _formBuilder: FormBuilder,
    private http: HttpClient,
    private router: Router
  ) {}
  ConfirmedValidator(password: any, confirmpassword: any) {
    return password == confirmpassword;
  }
  MatchPassword(passwords: any, confirmpassword: any) {
    let password = passwords;
    if (confirmpassword.touched || confirmpassword.dirty) {
      let verifyPassword = confirmpassword.value;

      if (password != verifyPassword) {
        confirmpassword.setErrors({ MatchPassword: true });
      } else {
        return null;
      }
    }
  }
  ngOnInit() {
    // this.route.queryParams.subscribe(params => {
    //   this.name = params['name'];
    // });
    this.activeRoute.queryParams.subscribe((params) => {
      this.param = params;
      this.list2 = this.param.code;
      // // console.log(this.list2)
      localStorage.setItem("tokem", this.list2);
    });

    // debugger;
    // const param = this.route.snapshot.paramMap.get('code');
    // if(param) {
    //   this.Code = param;
    // }
    // this.param = this._activatedroute.snapshot.paramMap.get('id');
    // // this.router.navigate(['/reset_pass']);
    // // console.log(this.param)
    this.firstFormGroup = this._formBuilder.group(
      {
        password: ["", [Validators.required, Validators.minLength(8)]],
        confirmPassword: ["", [Validators.required]],
      },
      {
        validator: PasswordValidation.ValidateUrl,
      }
    );
    this.myError = (controlName: string, errorName: string) => {
      return this.firstFormGroup.controls[controlName].hasError(errorName);
    };
    //   this.param = this.route.params.subscribe(params => {
    //     this.name = +params['id']; // (+) converts string 'id' to a number
    //     // console.log(this.param)

    //     // In a real app: dispatch action to load the details here.
    //  });
  }

  username: string = "";
  password: string = "";
  show: boolean = false;

  submit() {
    this.gets = localStorage.getItem("tokem");
    var body: any = new FormData();
    body.append("new_password", this.firstFormGroup.value.password);
    body.append("code", localStorage.getItem("tokem"));
    // this.http.post<any>(environment.API_URL + "password_reset/confirm/", body).subscribe(
    //   data => {
    //     Swal.fire("Password reset successfull")
    //     this.router.navigate(['/login']);
    //   },
    //   (error) => {
    //     this.clear()
    //     Swal.fire(error.error.password[0])
    //     }

    //   )
    this.http
      .post<any>(environment.API_URL + "reset-password/", body)
      .subscribe(
        (data) => {
          Swal.fire(data.status);
          this.router.navigate(["/login"]);
        },
        (error) => {
          this.clear();
          Swal.fire(error.error.password[0]);
        }
      );
  }
  clear() {
    this.firstFormGroup.value.password = "";
    this.firstFormGroup.value.confirmPassword = "";
    this.show = true;
  }

  popup() {}

  // closePopup() {
  //   this.displayStyle = "none";
  // }
}
